import { render, staticRenderFns } from "./SelfcheckWorkspace.vue?vue&type=template&id=4496d168&scoped=true"
import script from "./SelfcheckWorkspace.vue?vue&type=script&lang=js"
export * from "./SelfcheckWorkspace.vue?vue&type=script&lang=js"
import style0 from "./SelfcheckWorkspace.vue?vue&type=style&index=0&id=4496d168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4496d168",
  null
  
)

export default component.exports